module.exports = __webpack_public_path__ + "static/turtle-creek-house40-11c14c0fa57b9e25f56282b00963c5b2.jpg";